import React,{ useRef,useMemo } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnsCompanyPurchases';
 import { Link,useNavigate } from "react-router-dom";
 import axios from "axios";
 import swal from 'sweetalert'; 
import '../jsx/components/table/FilteringTable/filtering.css';
import { Col, Row ,Dropdown} from 'react-bootstrap';
import InviteCustomer1 from '../jsx/constant/ListItem';
import InviteCustomer from '../components/SanadSaref';
import InviteCustomer2 from '../jsx/constant/AsnafExpenses';
import {Modal} from 'react-bootstrap';
import InviteCustomer3 from './InvoicepurchasesPrint';

import  { useEffect,useState     } from 'react';


export const CompanyPurchases = () => {
	const columns = useMemo( () => COLUMNS, [] )
	//const data = useMemo( () => MOCK_DATA, [] )
  const [data, setData] = useState([])
  const [datapopup, setDatapopup] = useState('')
  const [data2, setData2] = useState([])
  const invite3 = useRef();
    const [PaymentMethod, setPaymentMethod] = useState('')

   const [listitem, setListitem] = useState([])
 
  const [ID, setID] = useState(0)
  const [inviteModal , setInviteModal] = useState(false);
  const [inviteModal1 , setInviteModal1] = useState(false);
  const [report, setreport] = useState([])

  
	const tableInstance = useTable({
		columns,
		data,	
		initialState : {pageIndex : 0}
	}, useFilters, useGlobalFilter, usePagination)
  const [qun, setQun] = useState(0)

	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance
    const {globalFilter, pageIndex} = state	
    const navigate = useNavigate();

    const userdata = useRef();
    const invite1 = useRef();
    const invite = useRef();
    const invite2 = useRef();
    const [reastAmount, setReastAmount] = useState('')
    const [Amount, setAmount] = useState('')
    const [popupModal, setpopupModal] = useState(false)

   
  const userdata1 = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata1);
    const userid = userData.id;
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
  function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
 console.log('actionsForPage',pagePermissions); 
   if (pagePermissions) {
       return pagePermissions.action;
   } else {
  navigate('/dashboard_1')
      return [];
   }
 }             const [endDate, setEndDate] = useState("");

                 const [date, setDate] = useState("");
  useEffect(() => {
                    if (  date && endDate) {
                      fetchProducts();
                    }
                }, [ date, endDate]);
  const fetchProducts = async () => {
           
              const params = new URLSearchParams();
            
              // Add parameters based on input values
               if (date) params.append("date", date);
              if (endDate) params.append("endDate", endDate);
            
              try {
                const response = await fetch(`https://subk.education.com.ly/back/api/purchaseorders?${params.toString()}`);
                const data = await response.json();
                setData(data);
                
                if (!data || data.length === 0) {
               //   setmessages("لا توجد نتائج");
                }
              } catch (err) {
                //setError("Error fetching data.");
              } finally {
               // setLoading(false);
              }
            };
            
            const clearFilters = () => {
               setDate("");
               setEndDate('')
              setData([]); // Optional: Clear results when clearing filters
            };
 const pageName = 'CompanyPurchases';
 const actionsForPage = getActionsForPage(pageName);
  // const fetchProducts = async () => {
  //     await axios.get('https://subk.education.com.ly/back/api/purchaseorders').then(({ data }) => {setData(data); console.log('datafroget',data)}) 
  // }
    const deleteUser = async (e,id)=> {
        e.preventDefault();
        swal({
          title: "هل متأكد من الحدف",
          text: " في حال حدف الملف لايمكنك استعادة هدا الملف",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
    
            axios.delete(`https://subk.education.com.ly/back/api/expenses/${id}`)
            
              .then(res => {
                fetchProducts();
                swal({
                  title: "تم",
                  text: "تم الحدف بنجاح",
                  icon: "success",
                  timer: 2000,
                  button: false
                })
                navigate('#')
            
               
            });
        
          } else {
            swal("تم الغاء عملية الحدف");
          }
        
        });
    
    };
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
          </g>
        </svg>
    )
    const [Err, setERrr] = useState('');
    function orderlist(e,id) {
      console.log('id', id)
      setDatapopup(id)

      data.map((item) => {
        if (id == item.PurchaseOrderID) {
          //setTotalAmount(item.TotalAmount)
          //setPrepay(item.Prepay)
          //setPaystatus('مدفوع')
          setReastAmount(item.ReastAmount)
           setERrr('')
          setpopupModal(true)
        }
      })
    }
    const handleEdit = () => {
      setERrr('');
      console.log('reastAmount',reastAmount)
      console.log('Amount',Amount)

      if ( parseFloat(Amount) > reastAmount) {
        setERrr('القيمة المدخلة اكبر من القيمة المتبقية')
      } else {
         if (!PaymentMethod) {
    alert("من فضلك اختر طريقة الدفع");
    return;
  }
        const error = axios.post(`https://subk.education.com.ly/back/api/expenses`, {
          ['Amount']: Amount,
          ['ReastAmount']: reastAmount,
          ['PaymentMethod']: PaymentMethod,

            ['PurchaseOrderID']: datapopup,
          ['UserID']: userid,
  
        })  .then(({ data }) => {
  fetchProducts()       })
        if (!error.response) {
  
        } else {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
        setpopupModal(false)
       // let temp = data.map((data) => {
       //  if (IID === data.OrderID) {
         //   return { ...data, Status: 'تم التسليم' };
         // }
        //  return data;
      //  });
       // setData(temp);
       }
  
    }
    const EditData = async (e,id)=> {
      console.log(id);

      e.preventDefault();
      await axios.get(`https://subk.education.com.ly/back/api/expenses/${id}`).then(({ data }) => 
      {setData2(data.data)
        console.log('data',data2);
        console.log('data.darta',data2.data);
       } )
       .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
      setID(id);setInviteModal(true)
     // invite.current.showEmployeModal()
    }
    const EditData556 = async (e, id) => {
      console.log('idedit', id);
      const response = await axios.get(`https://subk.education.com.ly/back/api/getdipositpayed/${id}`);
      const depositData = response.data.Deposit;
       console.log('vvvvvvdepositDatavvvvvv', depositData);
  
      let singleamount = 0;
      if (depositData.length > 0) {
   
        // Map through depositData to create new objects
        const mappedData = depositData.map(deposit => {
          // Find the corresponding item in data based on OrderID
          const correspondingItem = data.find(item => item.PurchaseOrderID === deposit.PurchaseOrderID);
          singleamount += parseInt(deposit.Amount);
          console.log('singleamount', singleamount)
          const reastAmount = correspondingItem ? (correspondingItem.TotalAmount  - singleamount) : null;
  
          // Create a new object combining data from both sources
          return {
            Amount: deposit.Amount,
            CustomerName: correspondingItem ? correspondingItem.supplier.SupplierName : null,
            ExpenseDate: deposit.ExpenseDate,
            reference_number: deposit.reference_number,
            Description: deposit.Description,
            RestAmount: reastAmount,
            ExpenseType:deposit.expense_type.TypeName,
            InvoiceNumber:correspondingItem.InvoiceNumber
          };
        });
  
        console.log('mappedData', mappedData);
  
        // Update report state with mapped data
        setreport(mappedData);
  
        invite.current.showInviteModal()
      } else {
        swal(" لم يتم الدفع بعد");
  
      }
    }
const getfooditeming = async (e,id,sender)=> {
  data.map((item) => {
    if (id == item.PurchaseOrderID ) {
      setData2(item)
      console.log(item)
      console.log(item.details)

      setListitem(item.details)
      if(sender==='pdf')
      {invite3.current.showInviteModal()}
    else{setInviteModal1(true)}
           

    }

  })

} 
 const [errors, setErrors] = useState('')

 
const closepopup =  ()=> {
  setErrors('')

setpopupModal(false)

}
const getpopup = async (e,id)=> {
 
  setDatapopup(id)
setpopupModal(true)

}

         
    return(
<>
<div className='container-fluid'>
				<Row>
					<Col lg="12">
						<div className="card">
            <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   

                 <div className="tbl-caption">
                 <h4 className="heading mb-0"> المشتريات</h4>
                 <div>
                 {actionsForPage.includes('create') &&(
                                  < Link to={"#"} className="btn btn-primary btn-sm m-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite2.current.showPurchaseOrderModal()}
                               > + إضافة مشتريات  </Link> )} 
                                
                            </div>
                        </div>  
                        </div>   </div> 
                       <div className="col-xl-12">
              <div className="row align-items-center g-2">
 

  {/* Start Date Input */}
  <div className="col-xl-3 d-flex align-items-center">
    <label className="form-label m-2" style={{ whiteSpace: "nowrap" }}>من تاريخ:</label>
    <input className="form-control flex-grow-1" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
  </div>

  {/* End Date Input */}
  <div className="col-xl-3 d-flex align-items-center">
    <label className="form-label m-2" style={{ whiteSpace: "nowrap" }}>إلى تاريخ:</label>
    <input className="form-control flex-grow-1" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
  </div>

  {/* Buttons */}
  <div className="col-xl-3 d-flex align-items-center">
    <button className="btn btn-success btn-sm mt-1 ms-2" onClick={clearFilters}>إلغاء الفلترة</button>
  { /*  <button className="btn btn-primary btn-sm mt-1 ms-2" onClick={getall}>عرض الكل</button> */}
  </div>
</div>


</div>
       		 
                        
                        		 
								<div className="table-responsive">
									<table {...getTableProps()} className="table dataTable display table-hover">
										 <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

										{headerGroups.map(headerGroup => (
												<tr {...headerGroup.getHeaderGroupProps()}>
												      {headerGroup.headers.map((column) => (
                        // Check if the column accessor is 'age' and render accordingly
                        column.id !== 'AsnafExpensess' ? (
                          <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                            {column.canFilter ? column.render('Filter') : null}
                          </th>
                        ) : null
                      ))}
                                             <th style={{ paddingBottom: "4.5rem" }}>الفاتورة</th>
                                             <th style={{ paddingBottom: "4.5rem" }}>واصل الاستلام</th>

												</tr>
										))}
										</thead> 
                                        <tbody {...getTableBodyProps()} className="" >
                                        
                                        {page.map((row) => {
                                            prepareRow(row)
                                            return(
                                                <tr {...row.getRowProps()}>

                                                    {row.cells.map((cell) => (
          // Check if the column accessor is 'age' and render accordingly
          cell.column.id !== 'AsnafExpensess' ? (
            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ) :null
        ))}
<td> <Link   dir="rtl" className=""
                                    to={"#"} 
                                    onClick={(e) =>getfooditeming(e,row.original.PurchaseOrderID ,'pdf')}

                                    
                                   > <i class="fa-solid fa-file-lines fa-2x"></i>
                                  </Link>

 </td>
 <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => EditData556(e, row.original.PurchaseOrderID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>

                            </td>

                                                     <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        className="sharp i-false" 
                      >
                           {svg1}
                       </Dropdown.Toggle>
                      <Dropdown.Menu dir="rtl" className="dropdown-menu-right">
                    
                            {actionsForPage.includes('edit') && row.original.Status !== 'تم الدفع' && (
    <Dropdown.Item onClick={(e) => orderlist(e, row.original.PurchaseOrderID)}>
        <Link to="#" className="">
            صرف المبلغ
        </Link>
    </Dropdown.Item>
)}
                     
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
									</table>



									<div className="d-flex justify-content-between mx-2">
										<span>
											الصفحه{' '}
											<strong>
												{pageIndex + 1} من {pageOptions.length}
											</strong>{''}
										</span>
										<span className="table-index ">
											ادهب الى : {' '}
											<input type="number" 
												className="ml-2"
												defaultValue={pageIndex + 1} 
												onChange = {e => { 
													const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0 
													gotoPage(pageNumber)
												} } 
											/>
										</span>
									</div>
                                    <div className="text-center mb-3">  
                                        <div className="filter-pagination  mt-3">
                                            <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                {/* {'<'} */}
                                                <i className='fa-solid fa-angle-right' />
                                            </button>
                                            
                                            <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                السابق
                                            </button>
                                            <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                                التالي
                                            </button>
                                            <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                                {/* {'>'} */}
                                                <i className='fa-solid fa-angle-left' />
                                            </button>
                                        </div>
                                    </div>
								</div>
						 
						</div>
					</Col>
				</Row>
			</div>
      <Modal className="fade bd-example-modal-sm" size="sm" id="exampleModal1" show={popupModal} centered>
        <div className="modal-content">
          <div className="modal-body">
            <div className="col-sm-12 mb-2">
              <div>
                <label className="form-label">القيمة المبقية : {reastAmount}</label>
              </div>
              <div>
                <label className="form-label">ادخل باقي القيمة<span className="text-danger">*</span></label>
              </div>
              <input type="text"
                className="form-control"
                defaultValue=''

                //placeholder="ادخل قيم عددية صحيحه  فقط"
                required
                id="inputcity"
                name="city"
                onChange={(e) => setAmount(e.target.value)} ></input>

            </div>
                        <div style={{ color: "red" }}>{Err}</div>

                <div className="col-md-12 d-flex mb-2">
                                        <label className="form-label m-1" style={{ whiteSpace: "nowrap" }}>طريقة الدفع:</label>
                                        <select
                                        required
                                            className="form-control"
                                            name="Paid"
                                            value={PaymentMethod}
                                             onChange={(e) => setPaymentMethod(e.target.value)}
                                        >
                                            <option value="" >اختر</option>
                                            <option value="cash">كاش</option>
                                            <option value="card">بطاقة</option>
                                        </select>
                                    </div>
            <div className="card-footer" >

              <button type="button" className="btn btn-primary light mx-1" onClick={handleEdit}>اضف</button>

              <button type="button" className="btn btn-danger light" onClick={() => setpopupModal(false)}>اغلاق</button>
            </div>
          </div>
        </div>

      </Modal>
      <InviteCustomer3
                ref={invite3} 
                 data1={data2}
                data={listitem}
                />
       <InviteCustomer2
                ref={invite2}     
                parentFunction={fetchProducts}  
            /> 
         <InviteCustomer
                ref={invite} 
                 data={report}
              
                />     
      
</>


    );
}
export default CompanyPurchases;